import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the attendanceControl state domain
 */

const selectAttendanceControlDomain = state =>
  state.attendanceControl || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by AttendanceControl
 */

const selectAttendanceData = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate.attendanceData,
  );

const selectAttendanceLoading = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate.loading,
  );

const selectAttendanceLoadingChange = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate.loadingCnahge,
  );

const selectAttendanceError = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate.error,
  );

const selectAttendanceControlDeleteSuccessful = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate.deleteSuccessful,
  );

const makeSelectAttendanceControl = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate,
  );

export default makeSelectAttendanceControl;
export {
  selectAttendanceControlDomain,
  selectAttendanceData,
  selectAttendanceLoading,
  selectAttendanceError,
  selectAttendanceControlDeleteSuccessful,
  selectAttendanceLoadingChange,
};
